import { getInsuranceInfoStage } from '../forms/renderStage/insuranceInfo/InsuranceInfoStage'
import { RenderStage } from '../forms/renderStage/types'
import { GynHistoryStage } from './GynHistoryStage'
import { HealthHistoryStage } from './HealthHistoryStage'
import { MedsAndSupplmentsStage } from './MedsAndSupplementsStage'

export const renderGynStage: RenderStage = {
  insuranceInfo: getInsuranceInfoStage('gyn'),
  gynAndSexualHistory: GynHistoryStage,
  healthHistory: HealthHistoryStage,
  medicationsAndSupplements: MedsAndSupplmentsStage,
}
